import styled from "styled-components";

export const UserProfile = styled.div`
  .logo2 {
    width: 30px;
    height: 30px;
    margin: 0;
    margin-right: 20px;
  }

  @media (min-width: 450px) {
    .logo2 {
      width: 50px;
      height: 50px;
    }
  }
`;
